// Org/team tier. Legacy: checkOrgTier (snapshot L8664-8681) + effective-tier logic.
import { state, type Tier } from './../state'

export const API_BASE = (import.meta.env.VITE_API_BASE as string) || 'https://api.openlabelmaker.com'

/** Query the org endpoint; elevate to 'business' if the org subscription is active/trialing. */
export async function checkOrgTier(accessToken: string): Promise<void> {
  try {
    const resp = await fetch(`${API_BASE}/api/v1/org`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    const data = await resp.json()
    state.orgTier = data.org && ['active', 'trialing'].includes(data.org.subscription_status) ? 'business' : null
  } catch {
    state.orgTier = null
  }
}

/** The user's own tier from auth metadata (legacy user_metadata.tier). */
export function soloTier(): Tier {
  return ((state.currentUser?.user_metadata?.tier as Tier) || 'free')
}

/** Effective tier = org tier (if any) else the user's solo tier (legacy logic). */
export function effectiveTier(): Tier {
  return state.orgTier || soloTier()
}
